// Simple geocoding utility using OpenStreetMap Nominatim
// Converts a free-text address into a POINT(lon lat) WKT string

export interface GeocodingResult {
  wkt: string;
  lat: number;
  lon: number;
  displayName: string;
}

export const geocodeAddressToPointWKT = async (query: string): Promise<GeocodingResult | null> => {
  const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(query)}`;
  try {
    const response = await fetch(url, {
      headers: {
        // Nominatim usage policy recommends a valid UA/Referer
        'User-Agent': 'alldrivers-app/1.0',
        'Accept': 'application/json',
      },
    });
    if (!response.ok) return null;
    const data = await response.json();
    if (!Array.isArray(data) || data.length === 0) return null;
    const item = data[0];
    const lat = parseFloat(item.lat);
    const lon = parseFloat(item.lon);
    if (Number.isNaN(lat) || Number.isNaN(lon)) return null;
    return {
      wkt: `POINT(${lon} ${lat})`,
      lat,
      lon,
      displayName: item.display_name || query,
    };
  } catch (error) {
    console.error('Geocoding failed:', error);
    return null;
  }
};


